import React from 'react'
import { motion } from 'framer-motion'
import { Users, Music, Sparkles } from 'lucide-react'

const AboutWichita = () => (
  <div className="pt-16 lg:pt-20 min-h-screen">
    <section className="section-padding py-20">
      <div className="container-max max-w-5xl mx-auto">
        <motion.div className="text-center mb-12" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-5xl font-display font-bold text-white mb-4">Welcome to Wichita</h1>
          <p className="text-xl text-white/70">Events • Arts • Music • Food • Community</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {[{icon: Users, title: 'Community', text: 'A platform made by and for Wichita'}, {icon: Music, title: 'Culture', text: 'Live shows, galleries, festivals'}, {icon: Sparkles, title: 'Discovery', text: 'One hub for what’s happening now'}].map((f, i) => {
            const Icon = f.icon
            return (
              <motion.div key={f.title} className="glass-card p-8 text-center" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} viewport={{ once: true }}>
                <Icon size={36} className="text-le-accent mx-auto mb-4" />
                <h3 className="text-white font-semibold mb-2">{f.title}</h3>
                <p className="text-white/70">{f.text}</p>
              </motion.div>
            )
          })}
        </div>

        <div className="glass-card p-8">
          <h2 className="text-2xl font-display font-semibold text-white mb-3">A joint publication</h2>
          <p className="text-white/80">
            Welcome to Wichita is produced by Zippy Technologies LLC (platform design, infrastructure, AI) and Little Eddie Audio (editorial, reviews, and production leadership by Edwin Perry). We bring together happenings across the city into a fast, beautiful hub.
          </p>
        </div>
      </div>
    </section>
  </div>
)

export default AboutWichita

